import * as StringUtils from "./StringUtils";
import _ from "lodash";

export function spliceVariables(text, params) {
	if (!_.isUndefined(params) && params instanceof Array) {
		params.forEach((param) => {
			text = text.replace("%d", "" + param);
		});
	} else if (!_.isUndefined(params)) {
		text = StringUtils.template(text, params);
	}
	return text;
}
